<template>
    <div class="main-view">
        <home-nav class="m-hidden-view"></home-nav>
        <gzh-code-view class="m-hidden-view"></gzh-code-view>

        <div style="display: flex;flex-direction: column; width: 100%;min-height: calc(100vh - 380px); max-width: 900px;margin: 0 auto;">
            <div class="m-hidden-view" style="width: 100%;height:70px; background-color: #ffffff;border-radius: 10px;margin-top: 20px;">
                <div style="height: 70px;padding-left: 50px;display: flex;align-items: center;color: #666666">
                    <span>当前位置：</span>
                    <span style="margin-left: 10px;">首页</span>
                    <span style="margin-left: 10px;">></span>
                    <span style="margin-left: 10px;">游戏攻略</span>
                </div>
            </div>

            <div class="common-view">
                <span style="font-size: 18px;color: #888888;">暂无数据</span>
            </div>

        </div>

        <home-footer class="m-hidden-view"></home-footer>
    </div>
</template>

<script>
    import homeNav from "@/components/HomeNav";
    import homeFooter from "@/components/HomeFooter";
    import gzhCodeView from "@/components/GzhCodeView";

    export default {
        name: "HomeIntro",
        components: {
            homeNav,
            homeFooter,
            gzhCodeView,
        },
        data() {
            return {}
        },
        mounted() {

        },
        methods: {

        }
    }
</script>

<style scoped>
    .main-view {
        width: 100%;
        height: 100vh;
        overflow-y: scroll;
        background-color: #f5f5f5;
        position: relative;
        -ms-overflow-style: none;  /* IE 和 Edge */
        scrollbar-width: none;/* Firefox */
    }
    .main-view::-webkit-scrollbar {
        display: none;/* 兼容 Chrome, Opera, 和 Safari */
    }
    .common-view {
        width: 100%;
        background-color: #ffffff;
        border-radius: 10px;
        margin-top: 20px;
        height: 100px;
        margin-bottom: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    @media screen and (max-width: 900px) {
        .main-view {
        }

        .m-title {
            display: flex;
        }

        .p-title {
            display: none;
        }

        .m-hidden-view {
            display: none !important;
        }
    }
</style>